import {
  GET_NUTRITION_SUGGESTION,
  GET_NUTRITION_SUGGESTION_SUCCESS,
  GET_NUTRITION_SUGGESTION_ERROR,
  GET_COACHING_MESSAGE,
  GET_COACHING_MESSAGE_SUCCESS,
  GET_COACHING_MESSAGE_ERROR,
  GET_ASSESSMENT_SUMMARY,
  GET_ASSESSMENT_SUMMARY_SUCCESS,
  GET_ASSESSMENT_SUMMARY_ERROR,
} from './constants';

/**
 * Trigger a fetch of the smart nutrition suggestion. Cheap on the server
 * because of the cache layer — repeated dispatches in the same macro
 * bucket return the cached value without an LLM call.
 */
export function getNutritionSuggestion() {
  return { type: GET_NUTRITION_SUGGESTION };
}

export function getNutritionSuggestionSuccess(payload) {
  return { type: GET_NUTRITION_SUGGESTION_SUCCESS, payload };
}

export function getNutritionSuggestionError(err) {
  return { type: GET_NUTRITION_SUGGESTION_ERROR, err };
}

/**
 * Fetch the daily coaching message that renders at the top of HomeV2.
 * 12h server-side cache, so this call is cheap on repeated dashboard
 * opens within the same morning.
 */
export function getCoachingMessage() {
  return { type: GET_COACHING_MESSAGE };
}

export function getCoachingMessageSuccess(payload) {
  return { type: GET_COACHING_MESSAGE_SUCCESS, payload };
}

export function getCoachingMessageError(err) {
  return { type: GET_COACHING_MESSAGE_ERROR, err };
}

/**
 * Fetch the AI briefing for a trainer's view of a specific client.
 * Used by the V2 Assessment tab. Server caches 24h with a content-hash
 * key so saves auto-invalidate; cheap to call on every tab open.
 *
 * @param {string} clientId — User._id of the client being viewed.
 */
export function getAssessmentSummary(clientId) {
  return { type: GET_ASSESSMENT_SUMMARY, clientId };
}

export function getAssessmentSummarySuccess(payload, clientId) {
  return { type: GET_ASSESSMENT_SUMMARY_SUCCESS, payload, clientId };
}

export function getAssessmentSummaryError(err, clientId) {
  return { type: GET_ASSESSMENT_SUMMARY_ERROR, err, clientId };
}
